"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkNotificationAsReadEndpoint = void 0;
const mark_notification_as_clicked_1 = require("./mark-notification-as-clicked");
/**
 * @deprecated use MarkNotificationAsClickedEndpoint instead
 */
class MarkNotificationAsReadEndpoint extends mark_notification_as_clicked_1.MarkNotificationAsClickedEndpoint {
}
exports.MarkNotificationAsReadEndpoint = MarkNotificationAsReadEndpoint;
